let token: string | null = null;

export function setToken(value: string): void {
  token = value;
}

export function getToken(): string | null {
  return token;
}

export function clearToken(): void {
  token = null;
}
